import { createModalSlice } from 'shared/lib/factory/redux/createModalSlice'

export const taxFormSlice = createModalSlice('taxForm')
